import { useState } from "react";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import * as pathUtils from "../../../abstract/controller/utils/pathUtils";
import { isNonEmptyString, isNullish } from "../../../abstract/controller/utils/systemUtils";
import IconArrowClockwise from "../../../themes/icons/IconArrowClockwise";
import IconLock from "../../../themes/icons/IconLock";
import Labels from "../../label/Labels";
import styles from "./ReadOnlyParameterHeader.module.scss";

function ReadOnlyParameterHeader({ id, node, isFolded, setIsFolded }) {
  const [_isMouseOver, _setMouseOver] = useState(false);
  const _name = nodeUtils.getName(node);
  const _labels = nodeUtils.getLabel(node);
  const _idTarget = nodeUtils.getIdTarget(node);
  const _defaultValue = nodeUtils.getValueDefault(node);

  const _shouldShowFoldIcon = _isMouseOver && isNonEmptyString(_name);

  const handleMenuLeftFold = () => {
    setIsFolded(!isFolded);
  };

  const getFormClass = () => {
    return `${styles["header__form"]} ${isFolded ? styles["header__form--folded"] : ""}`;
  };

  const handleOnMouseOver = (e) => {
    e.stopPropagation();

    _setMouseOver(true);
  };

  const handleOnMouseOut = (e) => {
    e.stopPropagation();

    _setMouseOver(false);
  };

  return (
    <div className={styles["header"]} onMouseOver={handleOnMouseOver} onMouseOut={handleOnMouseOut}>
      {_shouldShowFoldIcon && (
        <div className={styles["icons-fold"]} onClick={handleMenuLeftFold}>
          <IconArrowClockwise />
        </div>
      )}
      <form onSubmit={(e) => e.preventDefault()} className={getFormClass()}>
        {!isFolded ? (
          <>
            <input
              type="text"
              className={styles["header__name-input"]}
              value={_name}
              disabled={true}
            />
            <TypeLinked idTarget={_idTarget} />
            <TypeDefault defaultValue={_defaultValue} />
            {_labels.length > 0 && <Labels node={node} readOnly />}
          </>
        ) : (
          <ViewFolded name={_name} />
        )}
      </form>
    </div>
  );
}

function TypeLinked({ idTarget }) {
  const _nameTarget = idTarget ? pathUtils.getName(idTarget) : "";

  if (!idTarget) {
    return null;
  }

  return (
    <div className={styles["header__linked"]}>
      <div className={styles["header__linked-flex"]}>
        <IconLock /> {pathUtils.getSeparatorGUI1()}
        <div className={styles["header__linked-lock"]}>{_nameTarget}</div>
      </div>
    </div>
  );
}

function TypeDefault({ defaultValue }) {
  if (isNullish(defaultValue)) {
    return null;
  }

  return (
    <div className={styles["header__default"]}>
      <div className={styles["header__default-flex"]}>
        <div className={styles["header__default-value"]}>{defaultValue}</div>
      </div>
    </div>
  );
}

function ViewFolded({ name }) {
  return (
    <div className={styles["fold-container"]}>
      <span className={styles["fold-full"]}>{name}</span>
    </div>
  );
}

export default ReadOnlyParameterHeader;
